import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faCertificate} from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Awards.scss';
import ieee1 from '../assets/images/ieee1.png';
import ieee2 from '../assets/images/ieee2.png';
import ieee3 from '../assets/images/ieee3.png';
import acm1 from '../assets/images/acm1.png';
import acm2 from '../assets/images/acm2.png';
import hack1 from '../assets/images/hack1.png';
import aws from '../assets/images/aws.png';
import oxf from '../assets/images/oxf.png';

function Awards() {
    return (
    <div className="container" id="awards">
        <div className="award-container">
            <h1>Awards & Licences</h1>
            <div className="award">
                <div className="award-content">
                    <p><FontAwesomeIcon icon={faTrophy} style={{ fontSize: '1.5em' }}/> 3x times top 50 programmer gloabaly by IEEE in IEEEXtreme contests</p>
                </div>
                <div className="media">
                    <img src={ieee1} className="zoom hide-on-mobile" alt="thumbnail" />
                    <img src={ieee2} className="zoom hide-on-mobile" alt="thumbnail"/>
                    <img src={ieee3} className="zoom" alt="thumbnail"/>
                </div>
            </div>
            <div className="award">
                <div className="award-content">
                <p><FontAwesomeIcon icon={faTrophy} style={{ fontSize: '1.5em' }}/> 2x times top 10 programmer in west Asia region in ACM-ICPC contests</p>
                </div>
                <div className="media">
                    <img src={acm1} className="zoom hide-on-mobile" alt="thumbnail" />
                    <img src={acm2} className="zoom" alt="thumbnail" />
                </div>
            </div>
            <div className="award">
                <div className="award-content">
                <p><FontAwesomeIcon icon={faTrophy} style={{ fontSize: '1.5em' }}/> Microsoft Youth Hackathon Winner 2024 - AI for Energy Efficiency</p>
                </div>
                <div className="media">
                    {/* <img src={hack1} className="zoom" alt="thumbnail"/> */}
                    <iframe 
                        className="zoom"
                        src="https://www.youtube.com/embed/3HsriDJI3Hc" 
                        title="YouTube video player" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" >
                    </iframe>
                </div>
            </div>
           <div className="award">
                <div className="award-content">
                <p><FontAwesomeIcon icon={faCertificate} style={{ fontSize: '1.5em' }}/> AWS Certified Solutions Architect - Associate</p>
                </div>
                <div className="media">
                </div>
            </div>
        </div>
    </div>
    );
}

export default Awards;
